import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import { PostUserFailure, PostUserRequest, PostUserSuccess } from './actions';
import { CreatedUser } from '@models/swagger';

export const featureKey = 'postUser';

export interface State {
  data: CreatedUser | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: null,
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(PostUserFailure, (state, { error }) => ({ ...state, data: null, error, loading: false })),
    on(PostUserRequest, state => ({ ...state, error: null, loading: true })),
    on(PostUserSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false }))
  )(state, action);
}
